import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailField"]

  connect() {
    this.updateVisibility()
  }

  change() {
    this.updateVisibility()
  }

  updateVisibility() {
    const checked = this.element.querySelector("input[type='radio']:checked")
    if (this.hasEmailFieldTarget) {
      this.emailFieldTarget.hidden = checked?.value !== "email"
    }
  }
}
